import React from 'react';
import { Button, GHOST_VARIANT, CONTAINED_VARIANT, BTN_DARK_THEME, NO_ICON, SIZE_44, } from '@yme/atoms/button';
import { noop, onOpenWindow, getSanitizeHtml } from '@yme/utils/common';
import { SELF } from '@yme/utils/constants';
import { ButtonsPanelStyled, ItemColumn, DescriptionStyled, DescriptionWrapper } from './styled';
export function ContentBlock({ description, primaryButton, secondaryButton, isButtonsHidden, }) {
    const secondaryButtonText = secondaryButton?.text;
    const finalText = getSanitizeHtml(description);
    const onClickHandler = (linkAction) => () => {
        if (linkAction) {
            onOpenWindow(linkAction, SELF);
        }
        else {
            noop();
        }
    };
    return (React.createElement(DescriptionWrapper, null,
        React.createElement(DescriptionStyled, { dangerouslySetInnerHTML: {
                __html: finalText,
            } }),
        React.createElement(ButtonsPanelStyled, null,
            primaryButton && !isButtonsHidden && (React.createElement(ItemColumn, null,
                React.createElement(Button, { buttonVariant: CONTAINED_VARIANT, hasIconButton: NO_ICON, size: SIZE_44, onClick: onClickHandler(primaryButton.link), label: primaryButton.text, colorSchema: BTN_DARK_THEME }))),
            secondaryButtonText && !isButtonsHidden && (React.createElement(ItemColumn, null,
                React.createElement(Button, { buttonVariant: GHOST_VARIANT, hasIconButton: NO_ICON, size: SIZE_44, onClick: onClickHandler(secondaryButton?.link), label: secondaryButtonText, colorSchema: BTN_DARK_THEME }))))));
}
ContentBlock.displayName = 'ContentBlock_Component';
